import { useQuery } from "@tanstack/react-query";

import { api, unwrap } from "./api";
import { downloadBlob } from "./exportPng";

export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result as string);
    r.onerror = () => reject(r.error);
    r.readAsDataURL(blob);
  });
}

/** <img> Authorization sarlavhasini yubora olmaydi, shuning uchun QR rasmini so'rab data URL qilamiz. */
export function useQrImage(propertyId: string, token?: string) {
  return useQuery({
    queryKey: ["qr-image", propertyId, token],
    queryFn: async () => {
      const blob = unwrap(
        await api.GET("/api/properties/{id}/qr/image/", {
          params: { path: { id: propertyId } },
          parseAs: "blob",
        }),
      ) as unknown as Blob;
      return blobToDataUrl(blob);
    },
  });
}

/** Stiker (PDF/PNG) ni so'rab, brauzer orqali saqlaydi. */
export async function downloadSticker(propertyId: string, fmt: "pdf" | "png", lang: "uz" | "ru") {
  const blob = unwrap(
    await api.GET("/api/properties/{id}/qr/sticker/", {
      params: { path: { id: propertyId }, query: { fmt, lang } as never },
      parseAs: "blob",
    }),
  ) as unknown as Blob;
  downloadBlob(blob, `elektr-pasport-${propertyId.slice(0, 8)}.${fmt}`);
}
